module.exports = "/assets/data/e037aa629f754f06699bede1e23c22ba-SA10.data.json";